const BASE_URL = process.env.REACT_APP_API_URL || '/api';

export default BASE_URL;
